import { Injectable } from "@angular/core";

import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from "../../environments/environment";


@Injectable()

export class SocketService {
	private socket: Socket;
	public socketConnected: boolean = false;
	public serialnumber: string;
	private pairingStarted: boolean = false;
	private remoteControlListenersAdded: boolean = false;
	private eventListeners = {
		product_statechange: null,
	}

	private ranking: BehaviorSubject<{ allData: Array<any>, newData: any }>;
	private fullRanking: BehaviorSubject<Array<any>>;

	constructor(
		private router: Router,
	) {
		this.ranking = new BehaviorSubject({ allData: [], newData: null });
		this.fullRanking = new BehaviorSubject([]);
	}

	async initialize() {
		this.connectSocket();
	}


	//--------------------------------------------------------------------- SOCKET
	private connectSocket() {
		this.log('connect to: ' + environment.game.url);
		this.socket = io(environment.game.url);

		// ON CONNECT:
		this.socket.on('connect', () => {
			this.socketConnected = true;
			//this.toastsService.showMessage('✅ SERVER CONNECTED', { id: 'api-socket' });
			this.socket.emit('join');
			this.socket.emit('join');
		});

		// ON DISCONNECT:
		this.socket.on('disconnect', () => {
			//this.toastsService.error('DISCONNECTED', { id: 'api-socket' });
			this.socketConnected = false;
		});

		// ERROR HANDLING:
		this.socket.on('connect_error', (data) => {
			//this.toastsService.error('NOT CONNECTED', { id: 'api-socket' });
		});

		//triggers ranking on start
		this.socket.on('ranking', (data) => {
			this.setRanking({ allData: data, newData: null });
		});

		//triggers ranking on changes
		this.socket.on('showRanking', (data, newData) => {
			this.setRanking({ allData: data, newData: newData });
		});

		//ranking admin
		this.socket.on('fullRanking', (data) => {
			this.setFullRanking(data);
		});

	}


	setRanking(data) {
		// Update observable subscribers:
		this.ranking.next(data);
	}
	setFullRanking(data) {
		// Update observable subscribers:
		this.fullRanking.next(data);
	}

	//--------------------------------------------------------------------- EMIT DATA over socket
	showRanking(onlyTop = false) {
		this.socket.emit('getRanking', onlyTop);
	}

	addScoreToRanking(deviceId: number, name: string, score: number) {
		this.socket.emit('addScore', { deviceId: deviceId, name: name, score: score });
	}

	deleteScore(item) {
		this.socket.emit('deleteScore', item);
	}

	//--------------------------------------------------------------------- LISTENERS
	onRankingUpdate(): BehaviorSubject<{ allData: Array<any>, newData: any }> {
		return this.ranking;
	}

	onFullRankingUpdate(): BehaviorSubject<Array<any>> {
		return this.fullRanking;
	}

	//----------------------------------------------------------------------------------------- LOG
	private log(...args) {
		const title = 'SOCKET.SERVICE';
		console.log('%c' + title, 'padding:0 2px; font-weight: bold; font-size:11px; background: #Fb0; color: #000', ...args);
	}
}



// WEBPACK FOOTER //
// /app/src/app/services/socket.service.ts